import React, { useState } from 'react';
import { View, Text } from 'react-native'
import { DateTime } from 'luxon';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './styles';
import DateInput from 'app/src/elements/DateInput';

const GeneralLedger = () => {
  const [startOn, setStartOn] = useState(
    DateTime.now().minus({ months: 1 }).startOf('month').toISODate()
  );

  const [endOn, setEndOn] = useState(
    DateTime.now().minus({ months: 1 }).endOf('month').toISODate()
  );

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'general-ledger',
      params: { 'start-on': startOn, 'end-on': endOn }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>General Ledger</Text>
      <Text style={styles.label}>Start On:</Text>
      <DateInput
        style={styles.select}
        onChange={e => setStartOn(e.target.value)}
        value={startOn || ''}
      />
      <Text style={styles.label}>End On:</Text>
      <DateInput
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default GeneralLedger;
